module.exports = __webpack_public_path__ + "media/images/icons/outlined/safety-certificate-8deb76e7372ab1db1daed44720120e2d.svg";